import { ChakraProvider } from '@chakra-ui/react'

import { BrandingSwitcher } from './BrandingSwitcher'
import { Footer } from './containers/Footer'
import { useCustomTheme } from './context/CustomThemeContext'
import { Router } from './Router'
// import { useNavigateLogger } from 'BrokerTsLib/src/hooks'

export const App = () => {
  const { customTheme, onThemeChange } = useCustomTheme()

  // zaloguje do console zmeny pri navigaci
  // useNavigateLogger()

  return (

    <ChakraProvider theme={customTheme}>
      <Router />
      <BrandingSwitcher />
      <Footer />
      {/* <ThemeSwitcher onThemeChange={onThemeChange} /> */}
    </ChakraProvider>

  )
}

export default App

